import { render, staticRenderFns } from "./Fuel.vue?vue&type=template&id=1f4e6afe&scoped=true&"
import script from "./Fuel.vue?vue&type=script&lang=js&"
export * from "./Fuel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f4e6afe",
  null
  
)

export default component.exports